import React from "react";
import { Modal, ModalBody } from "../../components/Common/AppOverlay";
import EngagementForm from "./EngagementForm";
import "./NewEngagementModal.scss";

export default function NewEngagementModal({ isOpen, onCancel, onSaved, ...formProps }) {
  return (
    <Modal isOpen={isOpen} size="lg" centered backdrop="static" keyboard={false}
      className="new-engagement-modal" aria-labelledby="new-engagement-title">
      <div className="modal-header">
        <h2 className="modal-title fs-5" id="new-engagement-title">
          {formProps.engagementId ? "Edit Engagement" : "New Engagement"}
        </h2>
      </div>
      <ModalBody className="p-0">
        {isOpen && <EngagementForm {...formProps} embedded onSaved={onSaved} onCancel={onCancel} />}
      </ModalBody>
    </Modal>
  );
}
